import { render, staticRenderFns } from "./EsportaCorsiSvolti.vue?vue&type=template&id=1f670c07"
import script from "./EsportaCorsiSvolti.vue?vue&type=script&lang=js"
export * from "./EsportaCorsiSvolti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports